export default __webpack_public_path__ + "static/media/edit.a14cef1c.svg";